var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cc-preview-module',{attrs:{"title":"证据信息","data":_vm.transformData}})}
var staticRenderFns = []

export { render, staticRenderFns }